import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../cardProduto/Produto.css';
import Produto from '../cardProduto/CardProduto';
import '../sliderProduto/Slider.css';
import './Grid.css';

function MaisVendidos() {
  const main = process.env.REACT_APP_MAIN;
  const [ebooks, setEbooks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [categories, setCategories] = useState([]);

  const apiUrl = process.env.REACT_APP_API;

  const customStyles = {
    control: (provided) => ({
      ...provided,
      color: 'black',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
    }),
    option: (provided, state) => ({
      ...provided,
      color: 'black',
      backgroundColor: state.isFocused ? '#e2e2e2' : 'white', // Opção destacada com hover
    }),
  };


  useEffect(() => {
    const fetchEbook = async () => {
      try {
        const response = await fetch(apiUrl + "ebook/");
        if (!response.ok) {
          throw new Error('Falha ao buscar o ebook');
        }
        const data = await response.json();

        // Converte "autores" de string para array onde necessário
        const parsedData = data.map(ebook => ({
          ...ebook,
          autores: typeof ebook.autores === 'string' ? JSON.parse(ebook.autores) : ebook.autores
        }));

        setEbooks(parsedData);
      } catch (error) {
        console.error('Erro ao buscar o ebook:', error);
      } finally {
        setIsLoading(false);
      }
    };


    const fetchCategories = async () => {
      try {
        const response = await fetch('https://insigneacademica.com.br/api/categorias');
        if (!response.ok) {
          throw new Error('Falha ao buscar as categorias');
        }
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Erro ao buscar as categorias:', error);
      }
    };

    fetchEbook();
    fetchCategories();
  }, []);

  const filteredEbooks = ebooks.filter(ebook => {
    const matchesCategory = selectedCategory
      ? ebook.categorias?.includes(selectedCategory)
      : true;

    const matchesSearch = searchTerm
      ? (
        ebook.titulo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ebook.autores?.some(author => author.toLowerCase().includes(searchTerm.toLowerCase()))
 ||
        ebook.categorias?.some(category => category.toLowerCase().includes(searchTerm.toLowerCase()))
      )
      : true;

    return matchesCategory && matchesSearch;
  });

  // Ordena as categorias em ordem alfabética e mapeia para opções do Select
  const categoryOptions = categories
    .map(category => ({
      value: category.nome,
      label: category.nome
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));

  return (
    <div className='publicacoes-grid-container'>
      <div className="breadcrumb">
        <Link to={main}>Início</Link>
        <span> / </span>
        <p className="active">Livros</p>
      </div>

      <h2>Livros Publicados</h2>

      {/* Barra de pesquisa e filtro por categoria */}
      <div className="filtros-container d-flex flex-column flex-md-row gap-2 align-items-center">
        <div className="filtro-pesquisa flex-grow-1 w-100">
          <div className="input-group">
            <span className="input-group-text bg-light border-0">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              id="pesquisa"
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Digite título, autor ou categoria"
            />
          </div>
        </div>

        <div className="filtro-categoria flex-grow-0 flex-grow-md-1">

          <Select
            className='cursor-pointer w-100'
            id="categoria"
            options={[{ value: '', label: 'Categorias' }, ...categoryOptions]}
            value={categoryOptions.find(option => option.value === selectedCategory) || { value: '', label: 'Categorias' }}
            onChange={(selectedOption) => setSelectedCategory(selectedOption?.value || '')}
            isClearable
            styles={{
              control: (base, state) => ({
                ...base,
                height: '38px',
                marginTop: '20px',
                borderColor: state.isFocused ? '#86b7fe' : '#ccc',
                fontSize: '14px',
                cursor: 'pointer',
                width: '100%',
              }),
              option: (base, state) => ({
                ...base,
                color: state.isFocused ? '#0056b3' : '#000',
                cursor: 'pointer',
                width: '100%'
              }),
              placeholder: (base) => ({
                ...base,
                color: '#6c757d',
                width: '100%'
              }),
            }}
            placeholder="Selecione ou pesquise uma categoria"
            noOptionsMessage={() => "Nenhuma categoria encontrada"}
          />
        </div>
      </div>


      {isLoading ? (
        <div className="loading-container">
          <div className="loading-circle"></div>
        </div>
      ) : (
        <>
          {filteredEbooks.length > 0 ? (
            <div className="todas-publicacoes-container">
              {filteredEbooks.slice().reverse().map((product) => (
                <Produto key={product.id} livro={product} />
              ))}

            
          </div>
          ) : (
            <div className="estado-vazio-container">
              <div className="estado-vazio">
                <div className="estado-vazio-conteudo">
                  <i className="bi bi-book" aria-hidden="true"></i>
                  <h3>Nenhum livro encontrado</h3>
                  <p>Tente alterar os filtros ou pesquisar por outro termo.</p>
                  <button className="botao-limpar-filtros" onClick={() => {
                    setSearchTerm('');
                    setSelectedCategory('');
                  }}>
                    🔄 Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          )}
        
        </>
      )}


    </div>
  );
}

export default MaisVendidos;
